import { Descriptions, Typography, Divider } from "antd";
import { Modal, Badge } from "../../../components/Common";

const { Paragraph, Text } = Typography;

const formatDate = (value) => {
  if (!value) return "-";
  try {
    return new Date(value).toLocaleString();
  } catch (error) {
    return value;
  }
};

const statusVariant = (code) => {
  if (code >= 200 && code < 300) return "success";
  if (code >= 400 && code < 500) return "warning";
  if (code >= 500) return "error";
  return "neutral";
};

const formatJson = (payload) => {
  if (!payload) return null;
  if (typeof payload === "object") {
    return JSON.stringify(payload, null, 2);
  }

  if (typeof payload !== "string") {
    return String(payload);
  }

  try {
    return JSON.stringify(JSON.parse(payload), null, 2);
  } catch (error) {
    return payload;
  }
};

const LogDetailsModal = ({ log, open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      footer={null}
      width={760}
      title="Log details"
    >
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Timestamp">
          {formatDate(log?.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="API Key">
          <Text code copyable>
            {log?.apiKey || "-"}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Endpoint">
          {log?.endpoint || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Status code">
          <Badge variant={statusVariant(log?.statusCode)}>{log?.statusCode}</Badge>
        </Descriptions.Item>
      </Descriptions>

      {log?.requestData && (
        <>
          <Divider orientation="left">Request</Divider>
          <Paragraph
            code
            copyable
            style={{ whiteSpace: "pre-wrap", overflowX: "auto" }}
          >
            {formatJson(log.requestData)}
          </Paragraph>
        </>
      )}

      {log?.responseData && (
        <>
          <Divider orientation="left">Response</Divider>
          <Paragraph
            code
            copyable
            style={{ whiteSpace: "pre-wrap", overflowX: "auto" }}
          >
            {formatJson(log.responseData)}
          </Paragraph>
        </>
      )}
    </Modal>
  );
};

export default LogDetailsModal;
